import { PERIOD } from './period';

export const TOOLTIP_DATE_FORMAT = {
  [PERIOD.DAY]: 'MMM D, YYYY, h:mm A',
  [PERIOD.WEEK]: 'MMM D, YYYY, h:mm A',
  [PERIOD.MONTH]: 'MMM D, YYYY, h:mm A',
  [PERIOD.QUARTER]: 'MMM D, YYYY',
  [PERIOD.YEAR]: 'MMM D, YYYY',
};

export const HISTORY_DATE_FORMAT = {
  lastDay: 'MMM D, YYYY',
  sameDay: 'MMM D',
  sameElse: 'MMM D, YYYY',
  lastWeek: 'MMM D, YYYY',
  lastYear: 'MMM D, YYYY',
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/constants/formats.js